import i18n from '../helper/i18n';
import {
	AllergyIconMap,
	AllergyType,
	DietaryHabitsIcon,
	DietaryHabitsItem,
	NutritionPhilosophyIconMap,
	NutritionPhilosophyType,
} from '../types/DietaryHabits';

export const allergyList: DietaryHabitsItem<AllergyType>[] = [
	{
		text: i18n('react.impulsCoach.dietaryHabits.allergies.none'),
		id: 'NONE',
		image: 'intolerances-none',
	},
	{
		text: i18n('react.impulsCoach.dietaryHabits.allergies.lactose'),
		id: 'LACTOSE',
		image: 'intolerances-lactose',
	},
	{
		text: i18n('react.impulsCoach.dietaryHabits.allergies.gluten'),
		id: 'GLUTEN',
		image: 'intolerances-gluten',
	},
];

export const nutritionPhilosophyList: DietaryHabitsItem<NutritionPhilosophyType>[] = [
	{
		text: i18n('react.impulsCoach.dietaryHabits.nutritionPhilosophyList.all'),
		id: 'MEAT_FISH',
		image: 'nutrition-all',
	},
	{
		text: i18n('react.impulsCoach.dietaryHabits.nutritionPhilosophyList.vegetarian'),
		id: 'VEGETARIAN',
		image: 'nutrition-vegetarian',
	},
	{
		text: i18n('react.impulsCoach.dietaryHabits.nutritionPhilosophyList.vegan'),
		id: 'VEGAN',
		image: 'nutrition-vegan',
	},
];

export const nutritionPhilosophyIconMap: NutritionPhilosophyIconMap = {
	MEAT_FISH: 'nutrition-all',
	UNKNOWN: 'nutrition-all',
	VEGAN: 'nutrition-vegan',
	VEGETARIAN: 'nutrition-vegetarian',
};

export const allergyIconMap: AllergyIconMap = {
	NONE: 'intolerances-none',
	UNKNOWN: 'intolerances-none',
	GLUTEN: 'intolerances-gluten',
	LACTOSE: 'intolerances-lactose',
	GLUTEN_LACTOSE: 'intolerances-gluten-lactose',
};

export const mapNutritionPhilosophyToIcon = (nutritionPhilosophy: NutritionPhilosophyType): DietaryHabitsIcon => {
	const nutritionItem = nutritionPhilosophyList.find((el) => el.id === nutritionPhilosophy);
	return nutritionItem ? nutritionPhilosophyIconMap[nutritionItem.id] : nutritionPhilosophyIconMap.UNKNOWN;
};

export const mapAllergiesToIcon = (allergies: AllergyType[]): DietaryHabitsIcon => {
	const allergiesItems = allergyList.filter((el) => allergies.includes(el.id));
	if (allergiesItems.find((a) => a.id === 'LACTOSE') && allergiesItems.find((a) => a.id === 'GLUTEN')) {
		return allergyIconMap.GLUTEN_LACTOSE;
	} else if (allergiesItems.length === 1) {
		return allergyIconMap[allergiesItems[0].id];
	} else {
		return allergyIconMap.UNKNOWN;
	}
};
